import React from "react";
import { Document, Page, Text, View, StyleSheet } from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    backgroundColor: "#f8f8f8",
  },
  header: {
    fontSize: 20,
    color: "green",
    marginBottom: 10,
    fontWeight: "bold",
    textAlign: "center",
  },
  section: {
    marginBottom: 20,
    padding: 10,
    backgroundColor: "white",
    borderRadius: 5,
    borderWidth: 1,
    borderColor: "#ccc",
  },
  goalTitle: {
    fontSize: 16,
    color: "blue",
    marginBottom: 4,
    fontWeight: "bold",
  },
  bold: {
    fontWeight: "bold",
    marginTop: 8,
  },
  italic: {
    fontStyle: "italic",
  },
});

// Componente PDF
function CarePlanPDFDocument({ careGoals, patientInfo }) {
  const { t } = useTranslation();
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.header}> {t("PatientAssignment.CarePlanSavedSuccessfully")}</Text>
        <Text style={{ marginBottom: 10, textAlign: "center" }}>
          {t("PatientAssignment.Belowisasummary")}:
        </Text>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          {/* Sección de información del paciente */}
          <View style={[styles.section, { flex: 1, marginRight: 10 }]}>
            <Text style={styles.bold}>{t("PatientAssignment.PatientAssignmentPDF.PatientInformation")}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentTable.FullName")}: {patientInfo.lastName}, {patientInfo.firstName}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentPDF.DOB")}: {patientInfo.dateOfBirth.split("T")[0]}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentPDF.Phone")}: {patientInfo.memberPhone ? patientInfo.memberPhone : "Unassigned" }</Text>
            <Text>{t("PatientAssignment.PatientAssignmentPDF.City")}: {patientInfo.city ? patientInfo.city : "Unassigned"}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentPDF.CareManager")}: {patientInfo.careManager ? patientInfo.careManager : "Unassigned"}</Text>
          </View>

          {/* Información básica */}
          <View style={[styles.section, { flex: 1, marginLeft: 10 }]}>
            <Text style={styles.bold}>{t("PatientAssignment.PatientAssignmentPDF.BasicInformation")}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentTable.MemberID")}: {patientInfo.memberId}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentTable.Gender")}: {patientInfo.gender}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentPDF.Address")}: {patientInfo.address ? patientInfo.address : "Unassigned"}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentPDF.OfficeLocation")}: {patientInfo.officeLocation ? patientInfo.officeLocation : "Unassigned"}</Text>
            <Text>{t("PatientAssignment.PatientAssignmentTable.PCP")}: {patientInfo.pcp ? patientInfo.pcp : "Unassigned"}</Text>
          </View>
        </View>

        {/* Objetivos del plan de cuidado */}
        {careGoals.map((goal, idx) => (
          <View key={idx} style={styles.section}>
            <Text style={styles.goalTitle}>{goal.name}</Text>
            <Text>{goal.description}</Text>

            <Text style={styles.bold}>{t("PatientAssignment.Treatments")}:</Text>
            {goal.treatments.length === 0 ? (
              <Text style={styles.italic}>{t("PatientAssignment.Notreatments")}</Text>
            ) : (
              goal.treatments.map((t, i) => (
                <Text key={i}>- {t.treatmentName}</Text>
              ))
            )}

            <Text style={styles.bold}>{t("PatientAssignment.FollowUps")}:</Text>
            {goal.followUps.length === 0 ? (
              <Text style={styles.italic}>{t("PatientAssignment.Nofollowups")}</Text>
            ) : (
              goal.followUps.map((f, i) => (
                <Text key={i}>- {f.followUpName}</Text>
              ))
            )}
          </View>
        ))}
      </Page>
    </Document>
  );
}

export default CarePlanPDFDocument;
